import React from 'react'
import { BoldText } from 'ui-common'
import { useTranslation } from 'react-i18next'

import './style.sass'

export default function FileUploadSizeDislaimer(): React.ReactNode {
	const { t } = useTranslation(['common'])
	return <BoldText className='FileDisclaimer'>{t('fileSizeDisclaimer')}</BoldText>
}
